<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="机构编码：" prop="code">
                <el-input v-model="model.code"></el-input>
            </el-form-item>
            <el-form-item label="机构名称：" prop="orgname">
                <el-input v-model="model.orgname"></el-input>
            </el-form-item>
            <el-form-item label="顺序：" prop="pxorder">
                <el-input v-model.number="model.pxorder"></el-input>
            </el-form-item>
            <el-form-item label="坐标：" prop="coordinate" v-if="pid==0">
                <el-input v-model="model.coordinate" placeholder="36.976219,113.432257"></el-input>
            </el-form-item>
            <el-form-item label="状态：" prop="state" v-if="pid==0">
                <el-select clearable v-model="model.state" placeholder="请选择">
                    <el-option v-for="item in enuObj('project_state')" :key="'project_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="项目简介：" prop="description" v-if="pid==0">
                <el-input type="textarea" :rows="4" v-model="model.description"></el-input>
            </el-form-item>
            <el-form-item label="OCR识别数量：" prop="ocr_count" v-if="pid==0">
                <el-input v-model.number="model.ocr_count"></el-input>
                <span class="tips" @click="showOcrDialog" v-if="model.id>0" style="cursor: pointer;color: #409EFF;text-decoration: underline;">点击查看OCR识别记录</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
        <OcrCountLogList
            width="800px"
            :data_id="model.id"
            :isshow="ocr_count_log_show"
            @on-close="closeOcrDialog">
        </OcrCountLogList>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel, checkExist, getModelById } from '@/api/common'
import OcrCountLogList from '../ocrlog/countlist.vue'

export default {
    name: "orgEdit",
    mixins: [editutil],
    components: {OcrCountLogList},
    props: {
        pid: {
            type: Number,
            default() {
                return 0
            }
        }
    },
    data() {
        return {
            model: {
                orgname: '',
                pxorder: '',
                coordinate: '',
                state: '',
                description: '',
            },
            getObj:{
                url:'/api/admin/org/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            exits_p_name:'code',
            exits_p_title:'编码',
            checkObj:{
                url:'/api/admin/org/checkCode',
                data:{}
            },
            rules: {
                code: [
                    {required: true, message: '机构编码不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                orgname: [
                    {required: true, message: '机构名称不能为空', trigger: 'blur'},
                    {validator: this.validOrgExist, trigger: 'blur' }
                ],
                pxorder: [
                    {required: true, message: '顺序不能为空', trigger: 'blur'},
                    {type: 'number', message: '顺序必须是数字值', trigger: 'blur'}
                ],
                state: [
                    {required: true, message: '项目状态不能为空', trigger: 'blur'},
                ],
            },
            old_check1: '',
            exits_p_name1:'orgname',
            exits_p_title1:'编码',
            checkObj1:{
                url:'/api/admin/org/check',
                data:{}
            },
            enu_name: ['project_state'],
            ocr_count_log_show: false,
        }
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/org/save'
                    }
                    this.model.pid = this.pid
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                    
                }
            })
        },
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data;
                        if (this.exits_p_name != '') {
                            this.old_check = this.model[this.exits_p_name];
                        }
                        if (this.exits_p_name1 != '') {
                            this.old_check1 = this.model[this.exits_p_name1];
                        }
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
        validOrgExist(rule, value, callback) {
            if (value.trim() != '') {
                let check = true;
                if (this.id > 0) {
                    if (this.model[this.exits_p_name1].trim() === this.old_check1.trim()) {
                        check = false;
                    }
                }
                if (check) {
                    this.checkObj1.data[this.exits_p_name1] = this.model[this.exits_p_name1].trim();
                    this.checkObj1.data['pid'] = this.pid
                    checkExist(this.checkObj1).then(res => {
                        if (res.code === 1) {
                            callback();
                        } else {
                            callback(new Error(this.exits_p_title1 + "重复"));
                        }
                    }).catch();
                } else {
                    callback();
                }
            }
        },
        formateData(){
            this.model.state = this.model.state+""
        },
        showOcrDialog(){
            this.ocr_count_log_show = true
        },
        closeOcrDialog(){
            this.ocr_count_log_show = false
        }
    }
};
</script>